import axios from '@dap/shared-utils/http.js';

export default {
    getToken (params = {}) {
        return axios.get('/user/api/user/auth_token', { params });
    },

    userLogin (params = {}) {
        return axios.post('/user/api/user/login', params);
    },

    getAuthInfo (params = {}) {
        return axios.get('/user/api/user/info', params);
    },

    getVersion () {
        return axios.get('/dapper/version');
    },
};
